import { render } from "./SubsidiariesInfo.vue?vue&type=template&id=0009d4c4&scoped=true"
import script from "./SubsidiariesInfo.vue?vue&type=script&lang=js"
export * from "./SubsidiariesInfo.vue?vue&type=script&lang=js"

import "./SubsidiariesInfo.vue?vue&type=style&index=0&id=0009d4c4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0009d4c4"]])

export default __exports__